__webpack_require__.p = "https://share.skratch.world/";